import * as t from 'io-ts'
import { DateFromISOString } from 'io-ts-types'

export const TPlan = t.strict({
  addedToBilling: t.boolean,
  appliedToCurrentUser: t.boolean,
  changesNumber: t.number,
  collaboratorNumber: t.number,
  default: t.boolean,
  description: t.string,
  hasFigma: t.boolean,
  hasGithub: t.boolean,
  hasGitlab: t.boolean,
  hasTranslatorRole: t.boolean,
  name: t.string,
  openAINumber: t.number,
  planId: t.string,
  priceAnnual: t.number,
  priceMonth: t.number,
  projectNumber: t.number,
  termNumber: t.number,
  subscriptionExpiresAt: t.union([DateFromISOString, t.null]),
  enterprise: t.boolean,
})

export type Plan = t.TypeOf<typeof TPlan>

export const TPlansList = t.array(TPlan)

export enum PlanInterval {
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export const TCreatedPaymentMethod = t.strict({
  clientSecret: t.string,
  payload: t.string,
})

export const TCharge = t.strict({
  amount: t.number,
  chargeId: t.string,
  createdAt: DateFromISOString,
  currency: t.string,
  status: t.union([
    t.literal('PAID'),
    t.literal('PENDING'),
    t.literal('FAILED'),
  ]),
  periodFrom: DateFromISOString,
  periodTo: DateFromISOString,
  planName: t.string,
})
